export const balanceData = [
  {
    color: "primary",
    title: "Digital",
  },
  {
    color: "warning",
    title: "Clothes",
  },
  {
    color: "secondary",
    title: "Electric",
  },
  {
    color: "light",
    title: "Footwear",
  },
];

export const latestTransactionData = [
  {
    name: "Darrell Steward",
    date: "16 Nov, 2024",
    amount: "$456.23",
    status: "Complete",
  },
  {
    name: "Floyd Miles",
    date: "22 Jan, 2024",
    amount: "$550.73",
    status: "Failed",
  },
  {
    name: "Ralph Edwards",
    date: "31 Dec, 2024",
    amount: "$785.26",
    status: "Complete",
  },
  {
    name: "Jerome Bell",
    date: "16 Nov, 2024",
    amount: "$458.14",
    status: "Failed",
  },
  {
    name: "Theresa Webb",
    date: "16 Nov, 2024",
    amount: "$263.24",
    status: "Complete",
  },
  {
    name: "Courtney Henry",
    date: "01 Nov, 2024",
    amount: "$785.14",
    status: "Complete",
  },
];

export const userVisitsByDayData = [
  {
    color: "primary",
    title: "Chrome",
  },
  {
    color: "primary-1",
    title: "Firefox",
  },
  {
    color: "primary-2",
    title: "Safari",
  },
];

export const teamActivityTableBody = [
  {
    image: "50.png",
    name: "Floyd Miles",
    time: "5 min ago",
    activity: "Floyd has moved to the warehouse.",
  },
  {
    image: "51.png",
    name: "Ralph Edwards",
    time: "6 min ago",
    activity: "Ralph has solved Mr.williams project.",
  },
  {
    image: "33.png",
    name: "Esther Howard",
    time: "10 min ago",
    activity: "Esther has changed his to active, now.",
  },
  {
    image: "52.png",
    name: "Jacob Jones",
    time: "11 min ago",
    activity: "Jacob has make changes in sold it.",
  },
  {
    image: "53.png",
    name: "Theresa Webb",
    time: "12 min ago",
    activity: "Theresa has complete old task and new one.",
  },
  {
    image: "54.png",
    name: "Annette Black",
    time: "12 min ago",
    activity: "Annette has send all the stock to department.",
  },
];

export const newUsersProfile = [
  {
    image: "22.png",
    userName: "Smith John",
    country: "India",
  },
  {
    image: "28.png",
    userName: "Robert Fox",
    country: "Afghanistan",
  },
  {
    image: "26.png",
    userName: "Darlene Robtson",
    country: "Georgia",
  },
  {
    image: "24.png",
    userName: "Floyd Miles",
    country: "Pakistan",
  },
  {
    image: "49.png",
    userName: "Jacob Jones",
    country: "Monaco",
  },
];

export const topProductBodyData = [
  {
    image: "1.png",
    badge: "SKU90400",
    title: "Huawai Smart Watch",
    amount: "$39.02",
    quantity: [
      {
        subTitle: "QTY",
        count: "12",
      },
      {
        subTitle: "Revenue",
        count: "$51",
      },
      {
        subTitle: "QTY",
        count: "$15",
      },
    ],
  },
  {
    image: "2.png",
    badge: "SKU78589",
    title: "Noise - Wireless Headphone",
    amount: "$45.26",
    quantity: [
      {
        subTitle: "QTY",
        count: "19",
      },
      {
        subTitle: "Revenue",
        count: "$8",
      },
      {
        subTitle: "QTY",
        count: "$9",
      },
    ],
  },
  {
    image: "3.png",
    badge: "SKU78599",
    title: "Men & Women Footwear",
    amount: "$45.62",
    quantity: [
      {
        subTitle: "QTY",
        count: "9",
      },
      {
        subTitle: "Revenue",
        count: "$15",
      },
      {
        subTitle: "QTY",
        count: "$18",
      },
    ],
  },
  {
    image: "4.png",
    badge: "SKU78596",
    title: "Anime White Half Sleev T-shirt",
    amount: "$589.26",
    quantity: [
      {
        subTitle: "QTY",
        count: "9",
      },
      {
        subTitle: "Revenue",
        count: "$7",
      },
      {
        subTitle: "QTY",
        count: "$42",
      },
    ],
  },
];

export const deliveriesTableBodyData = [
  {
    particular: "On Time Delivery",
    value: 80,
    amount: "45,452.23",
  },
  {
    particular: "Delayed Delivery",
    value: 15,
    amount: "15,256.23",
  },
];
